import React, { useState } from 'react';
import './css/ModelImage.css';
import ZoomInIcon from './images/icons/zoom-in.png';
import ZoomOutIcon from './images/icons/zoomOut.png';

function ModelImage({ imageUrl, onClose, mobile }) {
  const [zoomLevel, setZoomLevel] = useState(1);

  const handleZoomIn = () => {
    setZoomLevel(zoomLevel + 0.1); 
  };

  const handleZoomOut = () => {
    if (zoomLevel > 1) {
      setZoomLevel(zoomLevel - 0.1);
    }
  };

  return (
    <div className="absolute inset-0 flex justify-center items-center bg-[#000] bg-opacity-75 p-10 z-[8888]" onClick={onClose}>
      <div className="w-full h-full flex justify-center items-center gap-3">
        <div className='w-full h-full flex justify-center items-center'>
          <img
            src={imageUrl}
            alt="Modal"
            className={`${mobile ? 'h-max' : 'h-full'} object-fill`}
            style={{ transform: `scale(${zoomLevel})` }}
          />
        </div>
        {/* <div className='modalImageDiv_ZoomDiv'>
          <div className='modalImageDiv_ZoomDivIn'>
            <img
              className='modalImageDiv_Btn_ZoomIn'
              src={ZoomInIcon}
              alt=''
              onClick={handleZoomIn}
            />
          </div>
          <div className='modalImageDiv_ZoomDivOut'>
            <img
              className='modalImageDiv_Btn_ZoomOut'
              src={ZoomOutIcon}
              alt=''
              onClick={handleZoomOut}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default ModelImage;
